import React, { useEffect, useState } from 'react'
import { Box, Typography, Container } from '@mui/material'
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowBtn from './ArrowBtn';
import { useLocation } from 'react-router-dom';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: 'none',
    boxShadow: 'none',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon  className='accordion_icon' />}
        {...props}
    />
))(({ theme }) => ({
    flexDirection: 'row',
    padding: 0,
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    }
}));


const FaqSection = ({ FAQS }) => {

    const { pathname } = useLocation()
    const [path, setPath] = useState('')
    useEffect(() => {
        setPath(pathname)
    }, [pathname])

    return (
        <>
            <Container maxWidth="xl" sx={{ margin: '5rem auto' }}>
                <Box className="faqBoxsec">
                    <h1 className='faq_h1'>FAQs</h1>
                    <Typography variant="body1" >
                        Welcome to WeCare’s boiler care FAQs section! Here, we aim to address common questions and <br /> concerns you may have about boiler maintenance, troubleshooting, and repairs.
                    </Typography>
                </Box>
                <div className="acorionswth">
                    {FAQS.map((item, i) => (
                        <Accordion defaultExpanded className='accordionBox' key={i}>
                            <AccordionSummary>
                                <Typography className='faq_title'>{item.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ padding: 0 }}>
                                <Typography className='faq_desc'>
                                    {item.desc}
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                    {path === "/Home" || '/Contect' ? null : (<div className='arrow_icons_faqs'>
                        <ArrowBtn />
                    </div>)}
                </div>
            </Container>
        </>
    )
}

export default FaqSection
